module.exports = __webpack_public_path__ + "static/media/savannah.c8a568f4.jpg";